import { AxiosPromise } from 'axios';
import { DropdownItem } from '../../types/WebPush';
import { libApiInstance } from '../axios';
import {
    WebPushActionRequest,
    WebPushCampaignResponse,
    WebPushSendRequest,
    WebSiteCapabilityResponse,
} from './types/webPush';

export function requestSendWebPush(
    data: WebPushSendRequest,
    signal?: AbortSignal,
): AxiosPromise<WebPushCampaignResponse> {
    return libApiInstance.post(`webpush`, data, { signal });
}

export function requestWebPushSites(signal?: AbortSignal): AxiosPromise<DropdownItem[]> {
    return libApiInstance.get(`/webpush/sites`, { signal });
}

export function requestWebSiteCapabilities(
    siteId: number,
    signal?: AbortSignal,
): AxiosPromise<WebSiteCapabilityResponse> {
    return libApiInstance.get(`/websites/${siteId}/capabilities`, { signal });
}

export function requestWebSiteCapabilityList(
    siteId: number,
    type: string,
    signal?: AbortSignal,
): AxiosPromise<DropdownItem[]> {
    return libApiInstance.get(`/websites/${siteId}/${type}`, { signal });
}

export function requestWebPushGenerateInternal(
    data: WebPushActionRequest,
    signal?: AbortSignal,
): AxiosPromise<WebPushSendRequest> {
    return libApiInstance.post(`webpush/internal/generate`, data, { signal });
}
